import React, { ReactElement, ReactNode } from 'react';
import { SortOrder, ColumnDescription } from 'react-bootstrap-table-next';
import { Placement } from '../../overlay';

export type Column = {
  dataField: string;
  text: string;
  component?: string | ReactElement | ((cell, row, rowIndex) => void);
  expandedCellRenderer?: (cell, row) => ReactElement;
  headerAlign?: string;
  isDummyField?: boolean;
  id?: number;
  isRequiredColumn?: boolean;
  isColumnSelected?: boolean;
  cellClasses?: string;
  componentClasses?: string;
  align?: string;
  onClick?: any;
  style?: any;
  headerStyle?: any;
  sort?: boolean;
  useCustomSortIcon?: boolean;
  headerTooltipPlacement?: Placement;
  onSort?: (field, order) => void;
  sortCaret?: (order, column) => ReactNode;
  headerFormatter?: (
    column,
    colIndex,
    { sortElement, filterElement },
  ) => ReactNode;
  switchOnTooltip?: string;
  switchOffTooltip?: string;
  tooltipPlacement?: Placement;
  overlayTooltipClass?: string;
  headerLoadingSkeleton?: ReactElement;
  cellLoadingSkeleton?: ReactElement;
  isCellClickable?: boolean;
  headerComponent?: () => React.ReactElement;
} & ColumnDescription;

export enum PaginationShowHide {
  HIDE = 'HIDE',
  SHOW = 'SHOW',
}

export type IState = {
  selectedRows: any[];
  expandedRowIds: number[];
  goToPage: number;
  showRowsPerPage: TablePageLengthDropDown;
  showBounce: boolean;
  isError: boolean;
  pgOptions: TablePageLengthDropDown[];
};

export type OverlayTooltipProps = {
  placement?: Placement;
  text?: string;
};

export type Action = {
  key: string;
  displayName: string;
  icon?: string;
  position?: string;
  conditionKey?: string;
  condition?: boolean;
  imageIcon?: any;
  customIcon?: boolean;
  iconElement?: ReactElement;
  isSVGIcon?: boolean;
  SVGIcon?: ReactNode;
  disabled?: boolean;
  overlayTooltip?: OverlayTooltipProps;
};

export type SortOptions = {
  dataField: string;
  order: SortOrder;
};

export type IProps = {
  columns: Column[];
  data?: any;
  actionColumnName?: string;
  actions?: Action[] | ((cell, row) => Action[]);
  onRowClickHandler?: (row) => void;
  tableWrapperClasses?: string;
  bodyWrapperClasses?: string;
  headerWrapperClasses?: string;
  newThemeActions?: boolean;
  onClick?: (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent>,
    row: any,
  ) => void;
  onChange?: (
    value: any,
    event: React.ChangeEvent<HTMLInputElement>,
    cell: any,
    row: any,
    index: number,
  ) => void;
  paginationOptions?: any;
  onPaginationOptionsChange?: any;
  onAction?: (key: string, row: any) => void;
  onRowSelect?: (row: any, checked: boolean) => void;
  onRowSelectAll?: (rows: any, checked: boolean, maxSelectedRowsLimit?: number) => void;
  resetSelected?: boolean;
  handleResetSelected?: VoidFunction;
  headerVisibleForGenerateColumn?: boolean;
  borderOverActions?: boolean;
  pagination: PaginationShowHide;
  sort?: SortOptions;
  id?: any;
  hidePageOptions?: boolean;
  isNewPagination?: boolean;
  tableRef?: any;
  deselectedRows?: any[];
  isLoading?: boolean;
  rowClasses?: string | ((row: any, rowIndex: number) => string);
  showExpandColumn?: boolean;
  isExpandColumnPositionFixed?: boolean;
  resetExpandedRows?: boolean;
  showColumnsToggler?: boolean;
  selectedColumnsIds?: number[];
  onColumnSelect?: (colIds: number[]) => void;
  sequenceFixedPageSize?: boolean;
  maxSelectedRowsLimit?: number;
  maxSelectedRowsLimitToolTip?: string;
  defaultSelectedRows?: number[];
  isRefreshClicked?: boolean;
  setOnRefresh?: (refresh: boolean) => void;
  onActionDropdownToggle?: (isOpen: boolean) => void;
  showRowsPerPage?: ShowingLengthPerPageOption;
  loadingRowsCount?: number;
  fixedPageSize?: number;
  hideActionColumnHeader?: boolean;
  useCustomSortIcon?: boolean;
  isSubsequence?: boolean;
  actionColumnRowSpanMapping?: Record<string, number>;
  emptyListTitle?: string;
  emptyListImgSrc?: string;
  customPaginationOptions?: ShowingLengthPerPageOption[];
  formattedTotalDisplay?: string;
  useFormattedTotalDisplay?: boolean;
  customPageLimit?: boolean;
};

export enum Sorting {
  Ascending = 'asc',
  Descending = 'desc',
}

export type TablePageLengthDropDown = {
  key: string;
  value: number;
};

export enum PaginationLocalStorageKey {
  ProspectRowsPerPage = 'prospect-rows-per-page',
}

export type ShowingLengthPerPageOption = {
  key: string;
  value: number;
};
